import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import styled from '@emotion/styled';
import useAppCustom from '@hooks/useAppCustom';

function Logo() {
  const custom = useAppCustom();
  return (
        <Column spacing={30} align='center' fullWidth>
            <LogoImage src={custom?.main.logo}
                       alt='로고' />
            <Text size='lg' style={{ textAlign: 'center' }}>
                프리미엄 멤버십 & 할인 혜택 이벤트<br/>
                앱에서만 만나보실 수 있어요
            </Text>
        </Column>
  );
}
const LogoImage = styled(Image)`
    width: 220px;
`;

export default Logo;
